import React from 'react';
import { Box, Text, HStack, Button, Image } from '@chakra-ui/react';

const Header = () => {
  return (
    <Box
      w="full"
      h={['100vh', '75vh']}
    >
      <Box
        w="100%"
        h='full'
        p={['1.75rem', '2rem', '2rem', '6rem']}
        display="flex"
        flexDirection={['column', 'row']}
        alignItems="center"
        justifyContent="space-evenly"
        bg="#fff"
      >
        <Box w={['100%', '50%', '50%', '50%']}  float="right" pl="1.5rem">
          <Text
            fontSize={['1.8rem', '2.5rem', '2.5rem', '4rem']}
            color="#1F1F29"
            fontFamily='Duplicate Sans'
            fontWeight="500"
          >
            Online Payment, Simplified
          </Text>
          <Text
            fontSize={['.75rem', '1rem']}
            lineHeight="28px"
            mt="1rem"
            color="#445368"
            fontFamily='Work Sans'
          >
            Don’t just get paid, withdraw your funds easily from your account
            with just your biometric
          </Text>
          <HStack mt="1rem" gap={['4', '2', '2', '2']}>
          <Button
              href="#services"
              _hover={{ textDecoration: 'none' }}
              textAlign="center"
              fontSize={['.75rem', '1rem', '.7rem', '1rem']}
              color="#fff"
              bg="#246BFD"
              fontFamily='Work Sans'
              w={['120px','160px']} h={['44px','54px']}
              p={['.75rem 1.5rem', ' 16px, 24px, 16px, 24px']}
              borderRadius="8px"
              fontWeight="500"
              _active={{ color: '#000' }}
            >
              Get Started&nbsp;{' '}
              <Image
                src="/hero_arrow.png"
                _hover={{ marginLeft: '.2rem' }}
                alt="socials"
              />
            </Button>
            
          </HStack>
        </Box>
        <Box display={['none','block']} w={['100%', '50%', '50%', '50%']}>
          <Image
            m="auto"
            w=""
            h="100%"
            src="/biometric payment illustration.svg"
            alt="mobile"
          />
        </Box>
        <Box display={['block','none']} w={['100%', '50%', '50%', '50%']}>
          <Image
            m="auto"
            w="100%"
            h="100%"
            src="/bpi.png"
            alt="mobile"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
